(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiftkey-neon-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shiftkey-neon-hero')) {
    customElements.define('shiftkey-neon-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (this.dataset.layout === 'split') {
          this.button = this.querySelector('.shiftkey-neon-hero__play');
          if (!this.video || !this.button || this.abort) return;
          this.abort = new AbortController();
          this.button.hidden = false;
          this.button.addEventListener('click', () => { this.video.play().catch(() => { this.button.hidden = false; }); }, { signal: this.abort.signal });
          this.video.addEventListener('play', () => { this.button.hidden = true; this.video.focus({ preventScroll: true }); }, { signal: this.abort.signal });
          this.video.addEventListener('ended', () => { this.button.hidden = false; }, { signal: this.abort.signal });
          return;
        }
        this.button = this.querySelector('.shiftkey-neon-hero__toggle');
        if (!this.video || !this.button || this.abort) return;
        this.abort = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlay = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.inView = false;
        this.updateLabel = () => { this.button.textContent = this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel; };
        this.syncPlayback = () => {
          if (this.wantsPlay && this.inView && !document.hidden) {
            this.video.play().catch(() => { this.updateLabel(); });
          } else { this.video.pause(); }
        };
        this.button.hidden = false;
        this.button.addEventListener('click', () => { this.wantsPlay = this.video.paused; this.syncPlayback(); }, { signal: this.abort.signal });
        this.video.addEventListener('play', this.updateLabel, { signal: this.abort.signal });
        this.video.addEventListener('pause', this.updateLabel, { signal: this.abort.signal });
        document.addEventListener('visibilitychange', this.syncPlayback, { signal: this.abort.signal });
        this.motion.addEventListener('change', event => { if (event.matches) { this.wantsPlay = false; this.syncPlayback(); } }, { signal: this.abort.signal });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.syncPlayback(); }, { threshold: .1 });
        this.observer.observe(this);
        this.updateLabel();
      }
      disconnectedCallback() {
        if (this.video) this.video.pause();
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiftkey-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shiftkey-product')) {
    customElements.define('shiftkey-product', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.data = JSON.parse(this.querySelector('[data-variant-data]').textContent);
        this.image = this.querySelector('.skp__main-image');
        this.addEventListener('change', event => {
          if (event.target.matches('input[name="id"]')) this.selectVariant(event.target.value, true);
        }, { signal: this.controller.signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-photo]');
          if (!button) return;
          this.showImage(button.dataset.photo, button.dataset.photoLabel, button.dataset.caption, button.dataset.photoLabel, button.dataset.original);
        }, { signal: this.controller.signal });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant') || this.data.variants[0]?.id;
          const input = [...this.querySelectorAll('input[name="id"]')].find(el => el.value === String(id));
          if (input) { input.checked = true; this.selectVariant(id, false); }
        }, { signal: this.controller.signal });
        this.selectVariant(this.querySelector('input[name="id"]:checked')?.value, false, new URL(window.location.href).searchParams.has('variant'));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      showImage(url, alt, caption, label, original = '') {
        if (!this.image || !url) return;
        this.classList.toggle('skp--photo', label !== this.data.labels.overview);
        if (this.image.src !== url) { this.image.removeAttribute('srcset'); this.image.removeAttribute('sizes'); this.image.src = url; }
        this.image.alt = alt || '';
        const originalLink = this.querySelector('[data-original-link]');
        originalLink.hidden = !original;
        if (original) originalLink.href = original; else originalLink.removeAttribute('href');
        this.querySelector('[data-image-caption]').textContent = caption || '';
        this.querySelector('[data-image-label]').textContent = label || '';
        this.querySelectorAll('[data-photo]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.photo === url)));
      }
      selectVariant(id, updateUrl, changeImage = true) {
        const variant = this.data.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        this.querySelector('[data-price]').textContent = variant.price;
        const compare = this.querySelector('[data-compare-price]');
        compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
        this.querySelector('[data-add]').disabled = !variant.available;
        this.querySelector('[data-add-label]').textContent = variant.available ? this.data.labels.add : this.data.labels.soldOut;
        this.querySelector('[data-selection]').textContent = this.data.labels.selected.replace('__TEXTURE__', variant.texture);
        const quantity = this.querySelector('input[name="quantity"]');
        quantity.min = variant.min; quantity.step = variant.step;
        if (variant.max !== null) quantity.max = variant.max; else quantity.removeAttribute('max');
        let value = Math.max(variant.min, Number(quantity.value) || variant.min);
        value = variant.min + Math.ceil((value - variant.min) / variant.step) * variant.step;
        quantity.value = variant.max !== null ? Math.min(value, variant.max) : value;
        const photo = [...this.querySelectorAll('[data-texture-photo]')].find(el => el.dataset.texturePhoto === variant.texture);
        if (changeImage) {
          if (variant.image) this.showImage(variant.image, variant.imageAlt, variant.texture, variant.texture);
          else if (photo) this.showImage(photo.dataset.photo, photo.dataset.photoLabel, photo.dataset.caption, photo.dataset.photoLabel, photo.dataset.original);
          else this.showImage(this.data.overview, this.data.overviewAlt, this.data.labels.caption, this.data.labels.overview);
        }
        if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
